module.exports = __webpack_public_path__ + "static/cad-designs12-4c2b145b5f65f1c14cdfeb3ed9bd9d04.png";